<div class="modal" *ngIf="!data.specific">
    <div class="modal-content">
      <h2>{{ data.title || ('modalGeneral.defaultTitle' | translate) }}</h2>
      <p [innerHTML]="data.message || ('modalGeneral.defaultMessage' | translate)"></p>
        <div class="actions">
            <button mat-raised-button 
                    [color]="data.type === 'error' ? 'warn' : data.type === 'success' ? 'accent' : 'primary'" 
                    class="linkedin-button" 
                    (click)="closeModal()"
                    *ngIf="!data.coming_from_extension"
                    >
                {{ data.buttonText || ('modalGeneral.continue' | translate) }}
            </button>
        </div>
    </div>
</div>

<div class="modal" *ngIf="data.specific">
    <div class="modal-content">
      <h2>{{ data.title || ('modalGeneral.defaultTitle' | translate) }}</h2>
      <p [innerHTML]="data.message || ('modalGeneral.defaultMessage' | translate)"></p>
        <div class="actions">
            <a href = "{{ data.link || 'https://www.linkedin.com' }}">
            <button mat-raised-button 
                    [color]="data.type === 'error' ? 'warn' : data.type === 'success' ? 'accent' : 'primary'" 
                    class="linkedin-button" 
                    (click)="closeModal()">
                    {{ data.buttonText || ('modalGeneral.continue' | translate) }}
                </button>
            </a>
        </div>
    </div>
</div>

